/**
 * Acceptance of the user terms ("Brukervilkår"), recorded on each account.
 *
 * A new member accepts the terms at sign-up, on the email form or the
 * Vipps/Google/Facebook confirm step. What is stored, in the account's private
 * data, is enough to show later who accepted which terms, when and in which
 * words:
 *
 *   privateData.termsAcceptance = { version, acceptedAt, wording }
 *
 * Existing members are not asked: they are told about new terms by email,
 * and the terms (§22) apply to them from the date that notice gives.
 */

import { TERMS_VERSION } from '../config/termsVersion';
import { BUSINESS_USER_TYPE } from './userTypes';

// Brukervilkår for Zuprize, versjon 21, gjeldende fra the release date
// (src/config/releaseDate.js). Set in src/config/termsVersion.js, which the
// server reads too.
export { TERMS_VERSION };

// Which sentence the member ticked. A private person confirms they are over
// 18 and use Zuprize as a private person; someone creating a business account
// from an invite confirms they may act for the business.
export const TERMS_WORDING_PRIVATE = 'private';
export const TERMS_WORDING_BUSINESS = 'business';

/**
 * @param {string} userType
 * @returns {'private'|'business'}
 */
export const termsWordingFor = userType =>
  userType === BUSINESS_USER_TYPE ? TERMS_WORDING_BUSINESS : TERMS_WORDING_PRIVATE;

/**
 * The record to store when someone ticks the box.
 *
 * @param {'private'|'business'} wording
 * @param {Date} [now]
 * @returns {{ version: string, acceptedAt: string, wording: string }}
 */
export const termsAcceptanceRecord = (wording, now = new Date()) => ({
  version: TERMS_VERSION,
  acceptedAt: now.toISOString(),
  wording,
});

/**
 * Was the terms checkbox ticked? FieldCheckbox gives `['yes']` when ticked.
 *
 * @param {Array|boolean|undefined} value
 * @returns {boolean}
 */
export const isTermsBoxTicked = value =>
  Array.isArray(value) ? value.includes('yes') : value === true;
